



















































import Vue from "vue";
import { SimpleListItem } from "../../types/simpleListItem";

export default Vue.extend({
    name: "SimpleList",
    props: {
        multiline: Boolean,
        items: { type: Array as () => SimpleListItem[] },
        showDivider: Boolean,
        showSkeleton: Boolean,
        icon: String,
        iconClass: String
    },
    data: () => ({
        selectedItem: -1
    }),
    created() {
        if (this.items && this.items.some(item => item.selected)) this.selectedItem = this.items.findIndex(item => item.selected);
    },
    methods: {
        getIconColor(item: any) {
            return item.iconColor ? item.iconColor : "primary";
        },
        isDividerVisible(index: number): boolean {
            return this.items && index + 1 < this.items?.length && this.showDivider;
        },
        isSkeletonVisible(): boolean {
            return this.items == null && this.showSkeleton;
        },
        itemClicked(item: SimpleListItem) {
            this.$emit("clicked", item);
        }
    }
});
